import { routesTemplate } from "../routesTemplate";

import LoginScreen from "../../screens/LoginScreen";
import RegisterScreen from "../../screens/auth/RegisterScreen";
import ToSScreen from "../../screens/auth/ToSScreen";

export const authStack = [
    routesTemplate('/', LoginScreen),
    routesTemplate('/register', RegisterScreen),
    routesTemplate('/tos', ToSScreen),
];
